export const API_PATH_ApiDeviceMgmtLocationsGet = '/services/devices-mgtm/apiDeviceMgmtLocationsGet';
